import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function trimmedMinLengthValidator(minLength: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    const errors: ValidationErrors = {};

    if (value?.trim().length < minLength) {
      errors['trimmedMinLength'] = `Die Eingabe muss mindestens ${minLength} Zeichen lang sein.`;
    }

    return Object.keys(errors).length ? errors : null;
  };
}
